import { DateTime } from 'luxon'

export const formatMonthsTitle = (startDate, endDate, diff = 0) =>
  [startDate, endDate]
    .map((d) => DateTime.fromISO(d).plus(diff).toFormat('MMM yyyy'))
    .join(' - ')
